import { initializeApp } from "firebase/app";
import { getMessaging, getToken, deleteToken } from "firebase/messaging";
import { getAuth, GoogleAuthProvider } from "firebase/auth";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

const app = initializeApp(firebaseConfig);
const messaging = getMessaging(app);

// Firebase Auth — used by Google Sign-In flow
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();

export { messaging };

export const generateToken = async () => {
  try {
    const permission = await Notification.requestPermission();
    if (permission !== "granted") {
      console.warn("Notification permission not granted");
      return null;
    }

    const currentToken = await getToken(messaging, {
      vapidKey: process.env.REACT_APP_FIREBASE_VAPID_KEY,
    });
    return currentToken;
  } catch (error) {
    console.error("Error generating FCM token:", error);
    return null;
  }
};

export const deleteFcmTokenWeb = async () => {
  try {
    const success = await deleteToken(messaging);
    console.log("FCM token deleted successfully");
    return success;   // ✅ now returns true/false
  } catch (error) {
    console.error("Error deleting FCM token:", error);
    return false;
  }
};
